var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKfin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 80,
    viewBox: "0 0 366 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.03 4H14.9698C7.25449 4 1 13.9178 1 26.1521V52.8479C1 65.0822 7.25449 75 14.9698 75H213.03C220.745 75 227 65.0822 227 52.8479V26.1521C227 13.9178 220.745 4 213.03 4Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.181 49.5765H71.6979L62.4852 38.1092V49.5765H59.0762V26.917H62.4852V38.0547L71.2309 26.917H75.3846L66.4754 37.8887L76.181 49.5765Z",
    fill: "#2057A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0781 49.5765V26.917H91.857V30.0796H81.4898V37.4502H90.5935V40.5843H81.4898V49.5765H78.0781Z",
    fill: "#2057A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8789 49.5765V26.917H98.2879V49.5765H94.8789Z",
    fill: "#2057A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.635 49.5753V26.4463L118.365 42.3681C118.347 41.2136 118.329 40.098 118.31 39.0265C118.292 37.955 118.282 36.8031 118.282 35.576V26.9159H121.61V50.1539L105.907 34.175C105.925 35.3295 105.943 36.4633 105.961 37.5711C105.979 38.6815 105.99 39.8126 105.99 40.9671V49.5753H102.635Z",
    fill: "#2057A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.711 49.5765V30.0796H124.166V26.917H140.721V30.0796H134.149V49.5765H130.711Z",
    fill: "#2057A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.281 49.5765V26.917H157.086V30.051H146.745V36.4851H155.353V39.5647H146.745V46.4398H157.498V49.5765H143.281Z",
    fill: "#2057A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.946 50.0114C169.26 50.0114 167.677 49.7079 166.203 49.1034C164.727 48.4989 163.44 47.6687 162.34 46.6153C161.24 45.562 160.374 44.3193 159.741 42.8898C159.108 41.4603 158.791 39.9114 158.791 38.2432C158.791 36.575 159.108 35.0262 159.741 33.5967C160.374 32.1671 161.24 30.9244 162.34 29.8711C163.44 28.8178 164.727 27.9928 166.203 27.396C167.68 26.7993 169.27 26.501 170.975 26.501C172.588 26.501 174.018 26.7215 175.266 27.16C176.511 27.601 177.531 28.0862 178.319 28.618V32.5226C177.878 32.1023 177.375 31.7105 176.807 31.3551C176.239 30.9971 175.634 30.6909 174.991 30.4341C174.35 30.1772 173.686 29.9801 172.996 29.8426C172.308 29.7051 171.626 29.6376 170.946 29.6376C169.698 29.6376 168.549 29.8581 167.495 30.2966C166.442 30.7376 165.534 31.3473 164.774 32.1256C164.014 32.9039 163.417 33.8172 162.986 34.8627C162.556 35.9083 162.34 37.0342 162.34 38.2458C162.34 39.4574 162.556 40.5834 162.986 41.6289C163.417 42.6744 164.014 43.5851 164.774 44.366C165.534 45.1443 166.442 45.754 167.495 46.195C168.549 46.6361 169.701 46.854 170.946 46.854C172.339 46.854 173.691 46.5894 175.004 46.0575C176.314 45.5257 177.419 44.8382 178.317 43.995V47.8996C177.492 48.4314 176.462 48.9166 175.224 49.3576C173.984 49.7909 172.56 50.0114 170.946 50.0114Z",
    fill: "#2057A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.111 49.5765V26.917H185.52V36.4592H196.658V26.917H200.067V49.5765H196.658V39.5932H185.52V49.5765H182.111Z",
    fill: "#2057A6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8594 54.9684L55.2624 54.4521L55.6437 54.875C55.8098 55.0592 55.6697 55.3498 55.4232 55.3368L48.8594 54.9684Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3974 20.833L34.8079 25.2098L28.7733 46.5798L22.8477 48.2376L30.3974 20.833Z",
    fill: "url(#paint1_linear_1_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4238 56.4568L15.7937 50.2147L37.8045 44.04L42.5808 48.7618L14.4238 56.4568Z",
    fill: "url(#paint2_linear_1_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0773 31.4082L55.2594 54.449L48.859 54.9627L31.2949 37.6062L33.0773 31.4082Z",
    fill: "url(#paint3_linear_1_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.793 50.2147L37.8039 44.04L42.5802 48.7618L15.793 50.2147Z",
    fill: "url(#paint4_linear_1_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M30.3974 20.833L28.7733 46.5798L22.8477 48.2376L30.3974 20.833Z",
    fill: "url(#paint5_linear_1_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.0773 31.4082L48.859 54.9627L31.2949 37.6062L33.0773 31.4082Z",
    fill: "url(#paint6_linear_1_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8076 25.2074L31.0301 20.112C30.89 19.9226 30.5917 19.9848 30.5372 20.2131L30.3945 20.828L34.8076 25.2074Z",
    fill: "url(#paint7_linear_1_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.793 50.2168L14.4231 56.4589L13.8653 56.6457C13.6448 56.7184 13.4373 56.503 13.5177 56.2851L15.793 50.2168Z",
    fill: "url(#paint8_linear_1_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4016 52.1576V53.0423H61.8285V53.8647H60.4016V54.8246H62.0153V55.6782H59.3379V51.3066H62.0153V52.1602H60.4016V52.1576Z",
    fill: "#1C2D47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2494 55.6733L66.3595 54.3346L65.576 55.6733H64.367L65.768 53.4499L64.3359 51.3018H65.576L66.4529 52.6223L67.226 51.3018H68.435L67.047 53.507L68.4921 55.6733H67.2494Z",
    fill: "#1C2D47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0512 53.4081C73.9345 53.6182 73.7555 53.7869 73.5168 53.9166C73.2755 54.0463 72.9772 54.1086 72.6191 54.1086H71.9602V55.6782H70.8965V51.3066H72.6217C72.9694 51.3066 73.2651 51.3663 73.5064 51.4883C73.7477 51.6076 73.9267 51.7736 74.0486 51.9864C74.1706 52.1991 74.2303 52.4404 74.2303 52.7154C74.2251 52.9671 74.1654 53.198 74.0512 53.4081ZM72.9927 53.1175C73.0913 53.0215 73.1432 52.8866 73.1432 52.7128C73.1432 52.539 73.0939 52.4041 72.9927 52.3081C72.8941 52.2121 72.7411 52.1654 72.5387 52.1654H71.9602V53.2602H72.5387C72.7411 53.2602 72.8915 53.2135 72.9927 53.1175Z",
    fill: "#1C2D47"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7102 52.1576V53.0423H79.1371V53.8647H77.7102V54.8246H79.3239V55.6782H76.6465V51.3066H79.3239V52.1602H77.7102V52.1576Z",
    fill: "#1C2D47"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1108 55.6733L83.2027 54.0233H82.9485V55.6733H81.8848V51.3018H83.6723C84.0174 51.3018 84.3106 51.3614 84.5544 51.4834C84.7983 51.6053 84.9799 51.7687 85.0992 51.9789C85.2186 52.189 85.2809 52.4225 85.2809 52.6794C85.2809 52.97 85.1978 53.2294 85.0344 53.4577C84.8709 53.686 84.6297 53.8469 84.308 53.9429L85.3172 55.6733H84.1108ZM82.9459 53.2709H83.6049C83.7995 53.2709 83.9473 53.2242 84.0433 53.1282C84.1419 53.0322 84.1886 52.8973 84.1886 52.7235C84.1886 52.5574 84.1393 52.4277 84.0433 52.3317C83.9447 52.2357 83.7995 52.189 83.6049 52.189H82.9459V53.2709Z",
    fill: "#1C2D47"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8762 51.3066V55.6782H87.8125V51.3066H88.8762Z",
    fill: "#1C2D47"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5793 52.1576V53.0423H94.0062V53.8647H92.5793V54.8246H94.193V55.6782H91.5156V51.3066H94.193V52.1602H92.5793V52.1576Z",
    fill: "#1C2D47"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.661 55.6733H99.5969L97.8179 52.9777V55.6733H96.7539V51.3018H97.8179L99.5969 54.0103V51.3018H100.661V55.6733Z",
    fill: "#1C2D47"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.401 52.3348C103.588 51.9976 103.847 51.7329 104.182 51.5435C104.516 51.3541 104.895 51.2607 105.318 51.2607C105.837 51.2607 106.281 51.3982 106.652 51.6707C107.02 51.9457 107.269 52.3193 107.394 52.7914H106.224C106.135 52.6098 106.013 52.4697 105.853 52.3737C105.692 52.2777 105.51 52.231 105.308 52.231C104.981 52.231 104.714 52.3452 104.511 52.5735C104.309 52.8018 104.205 53.108 104.205 53.4893C104.205 53.8707 104.306 54.1768 104.511 54.4052C104.714 54.6335 104.981 54.7476 105.308 54.7476C105.51 54.7476 105.692 54.7009 105.853 54.6049C106.013 54.5089 106.135 54.3714 106.224 54.1872H107.394C107.269 54.6594 107.023 55.033 106.652 55.3054C106.283 55.5778 105.837 55.7127 105.318 55.7127C104.895 55.7127 104.516 55.6193 104.182 55.4299C103.847 55.2405 103.588 54.9785 103.401 54.6412C103.214 54.304 103.121 53.92 103.121 53.4893C103.121 53.0587 103.214 52.6747 103.401 52.3348Z",
    fill: "#1C2D47"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.979 52.1576V53.0423H112.406V53.8647H110.979V54.8246H112.593V55.6782H109.916V51.3066H112.593V52.1602H110.979V52.1576Z",
    fill: "#1C2D47"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M121.483 51.3066V52.1602H120.326V55.6782H119.263V52.1602H118.105V51.3066H121.483Z",
    fill: "#1C2D47"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.115 55.6733L125.207 54.0233H124.953V55.6733H123.889V51.3018H125.677C126.022 51.3018 126.315 51.3614 126.559 51.4834C126.803 51.6053 126.985 51.7687 127.104 51.9789C127.223 52.189 127.286 52.4225 127.286 52.6794C127.286 52.97 127.202 53.2294 127.039 53.4577C126.876 53.686 126.634 53.8469 126.313 53.9429L127.322 55.6733H126.115ZM124.951 53.2709H125.61C125.804 53.2709 125.952 53.2242 126.048 53.1282C126.147 53.0322 126.193 52.8973 126.193 52.7235C126.193 52.5574 126.144 52.4277 126.048 52.3317C125.949 52.2357 125.804 52.189 125.61 52.189H124.951V53.2709Z",
    fill: "#1C2D47"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.535 54.9051H130.903L130.641 55.6782H129.525L131.108 51.3066H132.34L133.923 55.6782H132.797L132.535 54.9051ZM132.26 54.0826L131.717 52.4819L131.183 54.0826H132.26Z",
    fill: "#1C2D47"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M140.18 55.6733H139.117L137.337 52.9777V55.6733H136.273V51.3018H137.337L139.117 54.0103V51.3018H140.18V55.6733Z",
    fill: "#1C2D47"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.543 55.5667C143.289 55.463 143.086 55.3099 142.936 55.1049C142.785 54.9026 142.705 54.6561 142.697 54.3707H143.831C143.847 54.5316 143.904 54.6561 144 54.7417C144.096 54.8273 144.22 54.8688 144.373 54.8688C144.532 54.8688 144.656 54.8325 144.747 54.7599C144.838 54.6872 144.884 54.5861 144.884 54.4589C144.884 54.35 144.848 54.2618 144.775 54.1917C144.703 54.1217 144.615 54.062 144.508 54.0179C144.402 53.9712 144.251 53.9193 144.057 53.8622C143.774 53.774 143.543 53.6884 143.367 53.6002C143.188 53.512 143.035 53.3849 142.905 53.2136C142.775 53.0424 142.713 52.8219 142.713 52.5469C142.713 52.1395 142.861 51.8204 143.154 51.5921C143.45 51.3612 143.834 51.2471 144.306 51.2471C144.788 51.2471 145.175 51.3612 145.471 51.5921C145.766 51.823 145.922 52.1421 145.943 52.5546H144.791C144.783 52.4145 144.731 52.303 144.635 52.2226C144.539 52.1421 144.417 52.1006 144.267 52.1006C144.137 52.1006 144.033 52.1344 143.956 52.2044C143.878 52.2719 143.836 52.3704 143.836 52.5002C143.836 52.6403 143.904 52.7518 144.036 52.8296C144.168 52.9075 144.376 52.9931 144.659 53.0839C144.941 53.1799 145.17 53.2707 145.346 53.3589C145.523 53.4471 145.676 53.5716 145.803 53.7377C145.93 53.9037 145.995 54.1165 145.995 54.3785C145.995 54.6276 145.932 54.8533 145.805 55.0582C145.678 55.2606 145.494 55.424 145.255 55.5434C145.014 55.6627 144.731 55.725 144.402 55.725C144.083 55.7224 143.795 55.6705 143.543 55.5667Z",
    fill: "#1C2D47"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M151.364 51.3066V52.1602H149.584V53.0812H150.917V53.9088H149.584V55.6782H148.52V51.3066H151.364Z",
    fill: "#1C2D47"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M154.729 55.4383C154.386 55.2463 154.114 54.9817 153.914 54.6393C153.712 54.2968 153.613 53.9128 153.613 53.4847C153.613 53.0567 153.714 52.6727 153.914 52.3328C154.116 51.993 154.386 51.7258 154.729 51.5364C155.071 51.3444 155.447 51.251 155.86 51.251C156.272 51.251 156.648 51.347 156.991 51.5364C157.333 51.7258 157.603 51.993 157.8 52.3328C157.998 52.6727 158.096 53.0567 158.096 53.4847C158.096 53.9128 157.998 54.2968 157.798 54.6393C157.598 54.9817 157.328 55.2489 156.988 55.4383C156.648 55.6303 156.272 55.7237 155.862 55.7237C155.452 55.7237 155.071 55.6277 154.729 55.4383ZM156.698 54.4032C156.908 54.1697 157.012 53.8635 157.012 53.4822C157.012 53.0956 156.908 52.7869 156.698 52.5586C156.488 52.3277 156.21 52.2135 155.86 52.2135C155.507 52.2135 155.227 52.3276 155.017 52.556C154.806 52.7843 154.703 53.093 154.703 53.4847C154.703 53.8713 154.806 54.18 155.017 54.4084C155.227 54.6393 155.507 54.7534 155.86 54.7534C156.207 54.7534 156.488 54.6367 156.698 54.4032Z",
    fill: "#1C2D47"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M162.785 55.6733L161.877 54.0233H161.623V55.6733H160.559V51.3018H162.346C162.691 51.3018 162.985 51.3614 163.229 51.4834C163.472 51.6053 163.654 51.7687 163.773 51.9789C163.893 52.189 163.955 52.4225 163.955 52.6794C163.955 52.97 163.872 53.2294 163.708 53.4577C163.545 53.686 163.304 53.8469 162.982 53.9429L163.991 55.6733H162.785ZM161.62 53.2709H162.279C162.474 53.2709 162.621 53.2242 162.717 53.1282C162.816 53.0322 162.863 52.8973 162.863 52.7235C162.863 52.5574 162.813 52.4277 162.717 52.3317C162.619 52.2357 162.474 52.189 162.279 52.189H161.62V53.2709Z",
    fill: "#1C2D47"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.429 51.3066V55.6782H170.366V53.0579L169.388 55.6782H168.529L167.546 53.0501V55.6782H166.482V51.3066H167.74L168.967 54.3317L170.182 51.3066H171.429Z",
    fill: "#1C2D47"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M176.785 54.9051H175.153L174.891 55.6782H173.775L175.358 51.3066H176.59L178.173 55.6782H177.047L176.785 54.9051ZM176.512 54.0826L175.97 52.4819L175.436 54.0826H176.512Z",
    fill: "#1C2D47"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.667 51.3066V52.1602H182.51V55.6782H181.446V52.1602H180.289V51.3066H183.667Z",
    fill: "#1C2D47"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.134 51.3066V55.6782H186.07V51.3066H187.134Z",
    fill: "#1C2D47"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M190.712 55.4383C190.37 55.2463 190.097 54.9817 189.897 54.6393C189.695 54.2968 189.596 53.9128 189.596 53.4847C189.596 53.0567 189.698 52.6727 189.897 52.3328C190.1 51.993 190.37 51.7258 190.712 51.5364C191.054 51.3444 191.431 51.251 191.843 51.251C192.256 51.251 192.632 51.347 192.974 51.5364C193.317 51.7258 193.587 51.993 193.784 52.3328C193.981 52.6727 194.08 53.0567 194.08 53.4847C194.08 53.9128 193.981 54.2968 193.781 54.6393C193.581 54.9817 193.312 55.2489 192.972 55.4383C192.632 55.6303 192.256 55.7237 191.846 55.7237C191.436 55.7237 191.054 55.6277 190.712 55.4383ZM192.679 54.4032C192.889 54.1697 192.992 53.8635 192.992 53.4822C192.992 53.0956 192.889 52.7869 192.679 52.5586C192.468 52.3277 192.191 52.2135 191.841 52.2135C191.488 52.2135 191.208 52.3276 190.997 52.556C190.787 52.7843 190.683 53.093 190.683 53.4847C190.683 53.8713 190.787 54.18 190.997 54.4084C191.208 54.6393 191.488 54.7534 191.841 54.7534C192.191 54.7534 192.471 54.6367 192.679 54.4032Z",
    fill: "#1C2D47"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M200.446 55.6733H199.382L197.603 52.9777V55.6733H196.539V51.3018H197.603L199.382 54.0103V51.3018H200.446V55.6733Z",
    fill: "#1C2D47"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 48.8582,
    y1: 54.8962,
    x2: 55.7132,
    y2: 54.8962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    stopColor: "#09B0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#0495A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8119,
    stopColor: "#018593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 32.7123,
    y1: 23.6307,
    x2: 25.4614,
    y2: 46.9948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139FCE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3219,
    stopColor: "#139CCB",
    stopOpacity: 0.9322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5804,
    stopColor: "#1293C1",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    stopColor: "#1083B0",
    stopOpacity: 0.9816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 13.6949,
    y1: 53.9023,
    x2: 41.1965,
    y2: 46.0658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    stopColor: "#317CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#2D72BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#2561AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 53.0002,
    y1: 55.3207,
    x2: 33.1079,
    y2: 35.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#0ED1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    stopColor: "#0DC7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6499,
    stopColor: "#0AB6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    stopColor: "#069EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#00808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 14.8499,
    y1: 53.4437,
    x2: 40.2423,
    y2: 46.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#3079C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6923,
    stopColor: "#2869B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 32.2822,
    y1: 22.208,
    x2: 25.7794,
    y2: 47.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139FCE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    stopColor: "#129AC8",
    stopOpacity: 0.9265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#118AB8",
    stopOpacity: 0.9611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 52.9817,
    y1: 54.6315,
    x2: 32.5018,
    y2: 35.1202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    stopColor: "#0ECED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#0BBEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    stopColor: "#06A3AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 30.6924,
    y1: 20.4458,
    x2: 34.8429,
    y2: 25.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E719D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    stopColor: "#118AB8",
    stopOpacity: 0.9611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#129AC8",
    stopOpacity: 0.9265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139FCE",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2",
    x1: 13.5009,
    y1: 53.438,
    x2: 15.7921,
    y2: 53.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#2B6DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6997,
    stopColor: "#235DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfin);
export default __webpack_public_path__ + "static/media/kfin.840e53ff19d797828115b682aa867709.svg";
export { ForwardRef as ReactComponent };